/**
 * Single source of truth for current policy versions.
 * Bump these when Terms of Service or Privacy Policy are updated.
 * The middleware will force users to re-agree when versions change.
 */
export const TERMS_VERSION = "1.0";
export const PRIVACY_VERSION = "1.0";
